import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/services/http/http.service';
import { Observable } from 'rxjs';
import { EndPoints } from 'src/app/shared/EndPoints';
import { environment } from 'src/environments/environment';

@Injectable()
export class AnnouncementModalService {

  private CPPortalBaseUrl: string;

  constructor(private httpService: HttpService) {
    this.CPPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  public getAnnouncementPreLogin(): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getAnnouncementsPreLogon);
  }

  public getAnnouncementPostLogin(): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getAnnouncementsPostLogon);
  }

  public updateUserAnnouncement(request): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.updateUserAnnouncements, request);
  }

  public getBrowserVersions(): Observable<any[]> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.browserDetails);
  }

}
